const productGalleryInit = () => {
    const productGallery = document.querySelector(".ysw-product-gallery__slider");

    if (!productGallery) return null;

    const swiper = new Swiper(".ysw-product-gallery__slider", {
        pagination: {
            el: "",
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                direction: 'horizontal',
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1200: {
                direction: 'vertical',
                slidesPerView: 5,
                spaceBetween: 1,
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', productGalleryInit);
